import { isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';
import {
  toggleAuthFailed,
  toggleSessionExpired,
} from '@vs/rtk/slices/genericGlobal';

import { isUnAuthError } from '../errorHelper';

export const dispatchUnAuthErrorDialog: Middleware =
  (api: MiddlewareAPI) => next => action => {
    if (isRejectedWithValue(action)) {
      if (isUnAuthError(action.payload)) {
        if (
          action.meta.arg &&
          typeof action.meta.arg === 'object' &&
          'type' in action.meta.arg &&
          action.meta.arg.type === 'mutation'
        ) {
          api.dispatch(toggleAuthFailed(true));
        } else {
          api.dispatch(toggleSessionExpired(true));
        }
      }
    }

    return next(action);
  };
